<template>
  <div class="app-container">
    <BjPage ref="BjPage" :search-btn-hide="true" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="serial" :stripe="false" :selection="hasBtn && selection" right-toolbar-hide @handleSelectionChange="handleSelectionChange">
      <template v-slot:tableColumn>
        <el-table-column prop="skuName" :label="$t('goodsPage.skuName')" align="center"> </el-table-column>
        <el-table-column prop="standardSkuCode" :label="$t('OrdinaryOrderMix.GoodsInfoTab.SKU')" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="toView(scope.row)">{{ scope.row.standardSkuCode }}</el-button>
            <BjCopyIcon :copy="scope.row.standardSkuCode" />
          </template>
        </el-table-column>

        <el-table-column prop="spuCode" :label="$t('OrdinaryOrderMix.OrderItemTable.SPU')" align="center"> </el-table-column>
        <el-table-column prop="quantity" :label="$t('OrdinaryOrderMix.GoodsInfoTab.Quantity')" align="center"> </el-table-column>
        <template v-if="businessType == ORDER_BUSINESS_TYPES.COMMON">
          <el-table-column prop="preemptionStatus" :label="$t('OrdinaryOrderMix.GoodsInfoTab.occupied')" align="center"><template slot-scope="scope">
              {{ $t(ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST.bjGet(scope.row.preemptionStatus)) }}
            </template></el-table-column>
          <el-table-column prop="sourceStatus" :label="$t('OrdinaryOrderMix.GoodsInfoTab.Sourcing')" align="center"><template slot-scope="scope">
              {{ $t(ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST.bjGet(scope.row.sourceStatus)) }}
            </template></el-table-column>
          </template>
      </template>
    </BjPage>
    <!-- sku详情弹出框 -->
    <viewDialog ref="viewDialog"></viewDialog>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import viewDialog from './viewDialog.vue';
import { orderApi } from '@/api';
import {
  STATUS_YES_NUM,
  ORDER_INTERNAL_ORDER_STATUS_LIST,
  // #ifndef OPEN-SOURCE
  ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST,
  ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST,
  ORDER_INTERNAL_LINE_PREEMPT_BACK_STATUS_LIST,
  // #endif
  ORDER_INTERNAL_LINE_DELIVER_STATUS_LIST,
  ORDER_INTERNAL_LINE_RECEIVING_STATUS_LIST,
  ORDER_INTERNAL_LINE_STOCK_BACK_STATUS_LIST,
  ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST,
  ORDER_BUSINESS_TYPES,
} from '@/utils/constants';

export default {
  name: 'BusinessOrderInternalViewSkuLineList',
  components: { viewDialog },
  mixins: [pageMiXin],
  props: {
    orderId: {
      type: String,
      default: null,
    },
    hasBtn: {
      type: Boolean,
      default: true,
    },
    businessType: {
      type: String,
      default: ORDER_BUSINESS_TYPES.COMMON,
    },
  },

  data() {
    return {
      sortTableByOptionName: true,
      STATUS_YES_NUM,
      ORDER_INTERNAL_ORDER_STATUS_LIST,
      // #ifndef OPEN-SOURCE
      ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST,
      ORDER_INTERNAL_LINE_PREEMPT_BACK_STATUS_LIST,
      ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST,
      // #endif
      ORDER_INTERNAL_LINE_DELIVER_STATUS_LIST,
      ORDER_INTERNAL_LINE_RECEIVING_STATUS_LIST,
      ORDER_INTERNAL_LINE_STOCK_BACK_STATUS_LIST,
      ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST,
      ORDER_BUSINESS_TYPES,
      queryApi: orderApi.getInternalSkuLineListByOrder,
      // 查询参数
      queryParams: {
        deliveryStatus: null,
        // isOutStock: null,
        refundFlag: null,
        orderId: null,
        preemptionStatus: null,
        receiveStatus: null,
        sourceStatus: null,
        suspendStatus: null,
        syncDeliveryStatus: null,
        syncPreempStatus: null,
      },
      labelsVersion: 11,
      tableSortableDisabled: true,

      selectedRows: null,
    };
  },
  computed: {
    colWidth() {
      const O2O = this.businessType == ORDER_BUSINESS_TYPES.O2O;
      return {
        price: O2O ? '128' : '74',
        receivingStatus: O2O ? 'auto' : '70',
        giftFlag: O2O ? '100' : '50',
      };
    },
  },
  watch: {},
  created() {
    this.queryParams.orderId = this.orderId;
  },
  methods: {
    // 查看详情
    toView(r) {
      this.$refs.viewDialog.show(r);
    }
  },
};
</script>
